module.exports = __webpack_public_path__ + "static/img/swiper.286c93a.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/swiper.png
// module id = 4e8i
// module chunks = 0